import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { PVAPage } from '../../components';
import { SecondaryReportForm } from './SecondaryReportForm';
import { SecondaryReportDataService } from '../../services';
import { SecondaryReport } from '../../models';
import { NavLink } from 'react-router-dom';

interface SecondaryReportCreateState {
    secondaryReport: SecondaryReport;
}

export class SecondaryReportCreate extends React.Component<BaseRouteProps<{ id: number }>, SecondaryReportCreateState> {
    private secondaryReportDataService = new SecondaryReportDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{ id: number }>) {
        super(props);

        this.state = {
            secondaryReport: new SecondaryReport()
        };
    }

    public render() {
        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Buttons>
                        <NavLink to={'/surveyversion/' + this.props.match.params.id + '/secondaryreports'}>
                            <span className="glyphicon glyphicon-arrow-left" />
                        </NavLink>
                    </PVAPage.Header.Buttons>
                    <div className="title">Create Secondary Report</div>
                </PVAPage.Header>

                <PVAPage.Body>
                    <SecondaryReportForm defaultValues={this.state.secondaryReport} surveyVersionId={this.props.match.params.id} notificationService={this.props.notificationService} submit={(e: any) => this.save(e)} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.secondaryReportDataService.create(values).then((success) => {
            this.props.history.push(`/secondaryreport/${success.id}`);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/secondaryreport/SecondaryReportCreate.tsx